/** @file Export form to request: rig vs sprite-sheet options, fit omits scale, empty lists and fps 0 omitted. */
import type { ExportRequest } from '../../api/exportQuery';
import type { ExportFormState } from './exportForm';

const list = (key: 'animations' | 'skins' | 'directions', values: string[]): Partial<Record<typeof key, string[]>> =>
  values.length === 0 ? {} : { [key]: values };

/** The request the export tool takes (R20-04: an omitted scale fits a sprite sheet). */
export function toExportRequest(form: ExportFormState): ExportRequest {
  const common = { target: form.target, maxPage: form.maxPage, padding: form.padding, ...list('animations', form.animations), ...list('skins', form.skins) };
  if (form.target === 'rig') return { options: { ...common, scale: form.scale }, verify: form.verify };
  const sprite = {
    ...(form.fit ? {} : { scale: form.scale }), ...list('directions', form.directions),
    frameW: form.frameW, frameH: form.frameH, ...(form.fps > 0 ? { fps: form.fps } : {}), layout: form.layout,
  };
  return { options: { ...common, ...sprite }, verify: form.verify };
}
